export default __webpack_public_path__ + "static/media/grades-subject.ef9dca00.svg";